import { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Panel } from '../../ui/index.ts';
import { useGame } from '../GameContext.tsx';
import { EventFeed } from '../hud/EventFeed.tsx';
import { PhrasePad } from '../hud/PhrasePad.tsx';
import { PowerBar } from '../hud/PowerBar.tsx';
import { RouteStrip } from '../hud/RouteStrip.tsx';
import { TeamList } from '../hud/TeamList.tsx';
import { PuzzleCard } from '../puzzles/PuzzleCard.tsx';
import styles from './Heist.module.css';

const SectionScene = lazy(() => import('../scene/SectionScene.tsx'));

/** The execution and the escape: the puzzles of the room the team is in, and the team's tools. */
export function Heist() {
  const { t } = useTranslation('game');
  const { view } = useGame();
  const exec = view.exec;
  if (!exec) return null;
  const open = exec.puzzles.filter((p) => !p.solved);
  const solved = exec.puzzles.filter((p) => p.solved);

  return (
    <>
      <Suspense fallback={null}>
        <SectionScene />
      </Suspense>
      <RouteStrip />
      <div className={styles['layout']}>
        <section className={styles['puzzles']} aria-label={t('heist.puzzles')}>
          {open.map((p) => (
            <PuzzleCard key={p.id} entry={p} />
          ))}
          {open.length === 0 ? (
            <Panel tone="night">
              <p>{t('heist.moving')}</p>
            </Panel>
          ) : null}
          {solved.map((p) => (
            <PuzzleCard key={p.id} entry={p} />
          ))}
        </section>
        <aside className={styles['side']}>
          <PowerBar />
          <Panel tone="night">
            <TeamList compact />
          </Panel>
          <EventFeed limit={8} />
          <PhrasePad />
        </aside>
      </div>
    </>
  );
}
